import { X } from 'lucide-react'

/** Reason prompt shown when checking out before the shift's expected end
 * time — extracted from the "My Attendance" page so the check-in/out flow
 * can be reused elsewhere (e.g. the HR dashboard). */
export default function EarlyLeavePrompt({
  eodTime,
  reason,
  onReasonChange,
  onCancel,
  onContinue,
}: {
  eodTime: string
  reason: string
  onReasonChange: (value: string) => void
  onCancel: () => void
  onContinue: () => void
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/50" onClick={onCancel} />
      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-900">Leaving Early?</h2>
          <button onClick={onCancel} className="p-1 hover:bg-gray-100 rounded">
            <X className="h-5 w-5 text-gray-500" />
          </button>
        </div>
        <p className="text-sm text-gray-500 mb-4">Your shift ends at {eodTime}. Please provide a reason for leaving early.</p>
        <input
          type="text"
          value={reason}
          onChange={(e) => onReasonChange(e.target.value)}
          placeholder="e.g. Doctor appointment, personal errand..."
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand focus:border-brand mb-4"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && reason.trim()) onContinue()
          }}
        />
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={onContinue}
            disabled={!reason.trim()}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50"
          >
            Continue to Check Out
          </button>
        </div>
      </div>
    </div>
  )
}
